// extracted by mini-css-extract-plugin
module.exports = {"line":"TaskOriginLine_line__O6NAE","glyph":"TaskOriginLine_glyph__1JSNQ","label":"TaskOriginLine_label__Sjzr2","name":"TaskOriginLine_name__ifHfo"};